import React from 'react';
import { createElementKey } from 'utils';
import { Gallery, Section, SectionSubTitle, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import {
  entranceDoorsGalleryGrid,
  entranceDoorsGallerySectionList,
  entranceDoorsGallerySectionPointName,
  entranceDoorsGallerySectionTitle,
} from './entrance-doors-gallery-section-styles';
import {
  ENTRANCE_DOORS_GALLERY_POINTS_DATA,
  EntranceDoorsGalleryPointStructure,
  ENTRANCE_DOORS_GALLERY_LIST,
} from './entrance-doors-gallery-section-constants';

type EntranceDoorsGallerySectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const EntranceDoorsGallerySection: React.FC<EntranceDoorsGallerySectionProps> = ({
  onConsultationSignupBtnClick,
}) => (
  <Section>
    <SectionSubTitle adaptiveMargin margin="s">
      Создайте дверь вашей мечты
    </SectionSubTitle>
    <Typography className={entranceDoorsGallerySectionTitle} size="body_long" variant="m" adaptive={false}>
      Разнообразие вариантов фрезеровок, множество вариантов остекления, большая палитра цветов&nbsp;&mdash;
      у&nbsp;нас возможно всё!
    </Typography>
    <ul className={entranceDoorsGallerySectionList}>
      {ENTRANCE_DOORS_GALLERY_POINTS_DATA.map(
        ({ icon, text }: EntranceDoorsGalleryPointStructure, index: number) => (
          <li key={createElementKey('benefits', index)}>
            {icon}
            <Typography size="body_long" variant="m" className={entranceDoorsGallerySectionPointName}>
              {text}
            </Typography>
          </li>
        )
      )}
    </ul>
    <Gallery
      elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
      elementText="Создайте дверь вашей мечты"
      imageList={ENTRANCE_DOORS_GALLERY_LIST}
      imagePerPage={10}
      initialImagePerPage={10}
      modalBtnProps={{
        onClick: onConsultationSignupBtnClick,
      }}
      galleryGridClassName={entranceDoorsGalleryGrid}
    />
  </Section>
);
